import { fonts } from '@App/static/styles/global'
import styled from 'styled-components'
/**
 * Esta página exibe uma mensagem de confirmação para uma inscrição ou registro bem-sucedido.
 *
 * @return {JSX.Element}
 */
export function ThankYouPage({
    setIsSuccess
}: Readonly<{
    setIsSuccess?: (value: boolean) => void
}>) {
    return (
        <Body>
            <div className='img-container'>
                <img
                    src='https://framerusercontent.com/images/XbUNY0YTQuyvcuQq6jVWo7jWZc.png?width=159&height=159'
                    alt='check icon'
                    style={{ width: '100%' }}
                />
            </div>
            <p className='success-message-top'>Inscrição confirmada!</p>
            <span className='success-message-bottom'>
                Obrigado pelo seu interesse! Em breve, você receberá um e-mail
                com todas as informações.
            </span>
            {setIsSuccess && (
                <button className='go-back' onClick={() => setIsSuccess(false)}>
                    <img
                        src='/images/icons/arrow-back.svg'
                        alt='go back arrow icon'
                        style={{ width: '20px', marginRight: '6px' }}
                    />
                    <span>Voltar</span>
                </button>
            )}
        </Body>
    )
}

const Body = styled.div`
    min-height: 320px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 12px;

    .img-container {
        max-width: 44px;
        width: 100%;
        margin-bottom: 16px;
    }

    .success-message-top {
        font-size: 24px;
        text-align: center;
        font-weight: 600;
        margin-bottom: 8px;
        margin-top: 0;
        line-height: 1.2em;
    }

    .success-message-bottom {
        text-align: center;
        font-size: 18px;
        font-family: 'Roboto', sans-serif;
        color: rgb(60, 63, 76);
        line-height: 1.5em;
        margin-bottom: 24px;
    }

    .go-back {
        height: 40px;
        width: 114px;
        display: flex;
        justify-content: center;
        border-radius: 4px;
        border: 2px solid var(--Black-jotaBlack, #000);
        display: flex;
        align-items: center;
        cursor: pointer;

        span {
            color: var(--Black-jotaBlack, #000);
            text-transform: uppercase;
            ${fonts.jotaOverline()};
            padding-top: 3px;
        }
    }
`
